var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVagrantPlain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 14") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.51 23.9V12.82l-26.6 15.47v9.35L74.64 83.55l-10.65 7.33v33.61l22.81-13.15 35.71-87.44zM63.99 66.94L48.04 29.71V19.18l-.11-.05-15.85 9.16v9.35l21.28 47.92 10.63-5.26V66.94z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.56 3.51L79.97 19.08l-.02-.01V29.71L63.99 66.94v12.45l-10.63 6.17-21.28-47.92v-9.37l15.97-9.18-26.6-15.58-15.96 9.31v11.41l35.91 87.21 22.59 13.05V91.73l10.65-6.17-.14-.08 21.41-47.84v-9.35l.01-.02 26.59-15.45-15.95-9.31z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVagrantPlain);
export default __webpack_public_path__ + "static/media/VagrantPlain.c5ad8031148ab3c4c1c5f6fb746262cd.svg";
export { ForwardRef as ReactComponent };